import * as Sentry from '@sentry/browser'
import { useUserSessionStore } from '~/store/user-session'

export const useLogoutAndClearUserInfo = async (
  auth: ReturnType<typeof useAuth>
) => {
  const { signOut, status } = auth

  useUserSessionStore().$reset()
  if (status.value === 'authenticated') {
    await signOut({ external: true })
  }
  Sentry.setUser(null)
}
